module.exports = __webpack_public_path__ + "static/img/002.1f6d1807.png";